import type { FaireProductEntity } from "../../entity_types/product";

export const p_32vc8hf4e7: FaireProductEntity = {
  token: "p_32vc8hf4e7",
  type: "product",
  name: "18K Gold Plated Toggle Pearl Pendant Necklace wholesale",
  brandToken: "b_jbt25unvjp",
  brandName: "Gooddiy",
  imageUrl:
    "https://cdn.faire.com/fastly/57ce4c829a3a80d585953ef3a4435fe97b681502881068cd35e4bb1dfcc76558.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c8ad4ece90ad4f9b42b4919f42a4a2552e64f66b986c0379f0c8b9fe611cd2c.jpeg",
    "https://cdn.faire.com/fastly/03bd87b3e0565ebddcfa634b0dab10c54eb69e9778b21009afcb659daf058500.webp",
    "https://cdn.faire.com/fastly/69210b247273f0e0b40762a46c158f916f5b5699f3cc090c16afdd262549bf78.webp",
    "https://cdn.faire.com/fastly/e3ba711857e4b6fadd37760e2ed01b1f7dcf0da9f71731f09b91548e25035d38.webp",
    "https://cdn.faire.com/fastly/f31970fea72eb442fc4ad21275c7d76070eb310a53c63ced984ea6bc021af4bc.webp",
  ],
  priceDollars: 2.06,
  description:
    "Chain Material\t316 Stainless Steel\nChain Type\tball chain\nClassification\tPendant Necklace\nDesign\tToggle, Pearl\nGender\tWomen's\nGold Plating Process\tVacuum Plating\nMaterial\t316 Stainless Steel\nOccasion\tWeekend, Beach, Street\nPattern\tGeometric\nPendant Material\t316 Stainless Steel\nPlating Material\t18K Gold Plated\nQuantity\t1 Piece\nStyle\tIG Style, Simple Style\nWeight\t10g",
  tags: [],
  msrpDollars: 4.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:16.158Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
